import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "onboarding-summary16167__more-books"
}

import { computed } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import {
  BookSelection16167Choice,
  Summary16167Page,
} from '@/models/onboarding.types'
import { cacheBust } from '@/models/doc'

import Divider from '@/components/ui/Divider.vue'
import Layout from '../Layout.vue'
import Summary16167Section from '../Summary16167Section.vue'
import Summary16167Choices from '../Summary16167Choices.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Summary16167',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as Summary16167Page
})

const whatPreventsYouChoices = computed(() => {
  return props.view.getUserChoice<string[]>('what-prevents-you')
})

const genreChoices = computed(() => {
  return props.view.getUserChoice<string[]>('genre-selection')
})

const bookChoices = computed(() => {
  return props.view.getUserChoice<BookSelection16167Choice>('book-selection')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-summary16167",
    title: page.value.title,
    scrollDefaultSlot: true
  }, {
    default: _withCtx(() => [
      (whatPreventsYouChoices.value)
        ? (_openBlock(), _createBlock(Summary16167Section, {
            key: 0,
            title: "What stops me from reading more",
            class: "onboarding-summary16167__section onboarding-summary16167__section--what-prevents-you"
          }, {
            default: _withCtx(() => [
              _createVNode(Summary16167Choices, {
                pageID: "what-prevents-you",
                userChoices: whatPreventsYouChoices.value,
                view: __props.view
              }, null, 8, ["userChoices", "view"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (whatPreventsYouChoices.value)
        ? (_openBlock(), _createBlock(Divider, {
            key: 1,
            class: "onboarding-summary16167__divider"
          }))
        : _createCommentVNode("", true),
      (genreChoices.value)
        ? (_openBlock(), _createBlock(Summary16167Section, {
            key: 2,
            title: "The main areas I want to improve in",
            class: "onboarding-summary16167__section onboarding-summary16167__section--genres"
          }, {
            default: _withCtx(() => [
              _createVNode(Summary16167Choices, {
                pageID: "genre-selection",
                userChoices: genreChoices.value,
                view: __props.view
              }, null, 8, ["userChoices", "view"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (genreChoices.value)
        ? (_openBlock(), _createBlock(Divider, {
            key: 3,
            class: "onboarding-summary16167__divider"
          }))
        : _createCommentVNode("", true),
      (bookChoices.value)
        ? (_openBlock(), _createBlock(Summary16167Section, {
            key: 4,
            title: "Your top books",
            class: "onboarding-summary16167__section onboarding-summary16167__section--books"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookChoices.value.slice(0, 5), (book, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: book.id,
                  class: "onboarding-summary16167__book"
                }, [
                  _createElementVNode("img", {
                    src: _unref(cacheBust)(book.cover),
                    alt: "",
                    width: "158",
                    height: "211",
                    class: "onboarding-summary16167__cover"
                  }, null, 8, _hoisted_1),
                  (i === 4 && bookChoices.value.length > 5)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, " +" + _toDisplayString(bookChoices.value.length - 5), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})